import {type Extra} from '@lib/store';
import {ExtraTile, Tile} from '@organisms';
import {cn, getExtraItem} from '@utils';
import {useTranslation} from 'react-i18next';
import {useBreakPoint} from '@hooks';
import {PropsWithChildren} from 'react';
import {ExtrasLoader} from './ExtrasLoader';

export const ExtrasOverview = ({extras, loading}: {extras: Extra[]; loading: boolean}) => {
  const bp = useBreakPoint();
  const {t} = useTranslation();
  const extraItems = extras.map((e) => getExtraItem(e));

  // Hide when loaded & empty
  if (!loading && extras.length === 0) return <></>;

  return (
    <TileWrapper title={t('Services')}>
      {loading ? (
        <ExtrasLoader />
      ) : (
        <div className={cn('gap-6 w-full grid grid-cols-1', {'grid-cols-2': bp === 'large'})}>
          {extraItems.map(({iconLeft, name, url, id}) => {
            return (
              <ExtraTile
                key={id}
                iconName={iconLeft}
                title={name}
                url={url}
              />
            );
          })}
        </div>
      )}
    </TileWrapper>
  );
};

type WrapperProps = PropsWithChildren<{title: string}>;

const TileWrapper = ({title, children}: WrapperProps) => {
  return <Tile title={title}>{children}</Tile>;
};
